export const counties = [
  // { country: '臺南市', value: '67000' },
  { country: '台南市', value: '67000' },
  { country: '高雄市', value: '64000' },
  { country: '臺北市', value: '63000' },
  { country: '台北市', value: '63000' },
  { country: '臺中市', value: '66000' },
  { country: '台中市', value: '66000' },
  { country: '桃園市', value: '68000' },
  { country: '新北市', value: '65000' },
  { country: '臺東縣', value: '10014' },
  { country: '台東縣', value: '10014' },
  { country: '彰化縣', value: '10007' },
  { country: '嘉義縣', value: '10010' },
  { country: '嘉義市', value: '10020' },
  { country: '新竹縣', value: '10004' },
  { country: '新竹市', value: '10018' },
  { country: '雲林縣', value: '10009' },
  { country: '基隆市', value: '10017' },
  { country: '苗栗縣', value: '10005' },
  { country: '屏東縣', value: '10013' },
  { country: '南投縣', value: '10008' },
  { country: '花蓮縣', value: '64000' },
  { country: '宜蘭縣', value: '10002' },
  { country: '澎湖縣', value: '10016' },
  { country: '金門縣', value: '09020' },
]



// WEBPACK FOOTER //
// ./src/mocks/index.js